const userTypes = {
  GET_ALL_USER: 'GET_ALL_USER',
  SET_ALL_USER: 'SET_ALL_USER',
  UPDATE_USER_STATUS: 'UPDATE_USER_STATUS',
};

export default userTypes;
